export const MAX_VISIBLE_ROWS = 4;
export const HEIGHT_ANIMATION_DURATION_S = 0.25;
/** Until the swatches are measured the wrapper keeps its natural height, so they appear at full size immediately. */
export const NATURAL_HEIGHT = 'auto';
